import { Navigate, useLocation } from 'react-router-dom';

import { isCsAuthenticated } from '@/utils/store';
import CsNetworkToast from '@/components/CsNetworkToast';

interface CsAuthGuardProps {
  children: React.ReactNode;
}

/**
 * 客服端路由守卫
 * - 客服端已登录 → 显示 children
 * - 客服端未登录 → 跳转 /csLogin
 */
export default function CsAuthGuard({ children }: CsAuthGuardProps) {
  const location = useLocation();

  if (!isCsAuthenticated()) {
    return <Navigate to="/csLogin" state={{ from: location }} replace />;
  }

  return (
    <>
      <CsNetworkToast />
      {children}
    </>
  );
}
